import React, { useState, useEffect, useRef, useContext } from "react";
import _ from 'lodash';
import {
	Button,
	InputAdornment,
	FormControlLabel,
	IconButton,
	Checkbox,
	Modal,
	Container,
	FormControl,
	Stack,
	TextField,
	FormGroup,
	Box,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import PDFsContainerComponent from "../../../pdf-container-component/hoa-pool-access-form-pdf-container";
import { isValidHttpUrl } from "../../../../utility/input-field-validation";
import SourceIDVerificationCard from "../common/SourceIDVerificationCard";

const AddAccessInformationModal = ({
	open,
	onClose,
	view,
	state,
	setState,
	setAmenities,
	toBeEditedAccessInformation,
	setToBeEditedAccessInformation,
	setDocumentName,
	document,
	setSelectedDocument,
	toggleOpen,
	deleteOpen,
	tempAccessInformation,
	setTempAccessInformation,
	checkNewAmenitiesWarning,
}: any) => {
	const [checkError, setCheckError] = useState(false);
	const [sourceFileInfo, setSourceFileInfo] = useState([]);
	const [loading, setLoading] = useState(false);

	const generateUniqueId = () => {
		const timestamp = new Date().getTime();
		const randomNumber = Math.random().toString(36).substring(7);
		return `id_${timestamp}_${randomNumber}`;
	};
	useEffect(() => {
		if (toBeEditedAccessInformation) {
			setTempAccessInformation(toBeEditedAccessInformation);
		}
	}, [toBeEditedAccessInformation]);

	useEffect(() => {
		if (tempAccessInformation?.accessForm) {
			setSourceFileInfo(tempAccessInformation?.accessForm || []);
		}
	}, [tempAccessInformation]);

	const handleChange = (value: any, key: string) => {
		setTempAccessInformation({ ...tempAccessInformation, [key]: value });
	};

	const onSaveClick = () => {
		setCheckError(true);
		if (!tempAccessInformation.name) return;
		let tempState = JSON.parse(JSON.stringify(state));
		// let index = tempState.accessInformation.indexOf(toBeEditedAccessInformation);
		let index = tempState.accessInformation.findIndex((accessInformation: any) =>
			_.isEqual(accessInformation, toBeEditedAccessInformation)
		);
		const payload = { ...tempAccessInformation };
		payload.id = generateUniqueId();

		if (index >= 0) {
			tempState.accessInformation[index] = payload;
		} else {
			tempState.accessInformation.push(payload);
		}
		checkNewAmenitiesWarning(
			tempState.newAvialableAmenities,
			tempState.accessInformation,
			tempState.amenityEvents
		);
		setState(tempState);
		setAmenities([...tempState.accessInformation]);
		setTempAccessInformation({});
		setTempAccessInformation({});
		setCheckError(false);
		onClose();
	};

	const deleteClick = (document: string, name: any) => {
		setDocumentName(document);
		setSelectedDocument(name);
		toggleOpen(!deleteOpen);
	};
	const handleUploadClick = (id: string) => {
		const inputElement = document.getElementById(id);
		if (inputElement) {
			inputElement.click();
		}
	};
	const handleClose = () => {
		onClose();
		setCheckError(false);
		setToBeEditedAccessInformation({});
	};

	const addNewSourceDocument = () => {
		const newSource = {
			isVerified: false,
			sourceId: "",
			sourceIdType: "",
		};
		setSourceFileInfo([newSource, ...sourceFileInfo]);
	};

	const deleteSourceDocument = (index: number) => {
		let tempState = [...sourceFileInfo];
		tempState = tempState.filter((item, idx) => idx !== index);
		setSourceFileInfo(tempState);
		setTempAccessInformation({
			...tempAccessInformation,
			accessForm: tempState,
		});
	};

	const handleSourceFile = (e: any, index: number) => {
		const { name, value } = e.target;
		const tempState = [...sourceFileInfo];
		tempState[index][name] = value;
		if (name === "files" && value.length > 0) {
			tempState[index]["isVerified"] = true;
		} else if (name === "files" && value.length == 0) {
			tempState[index]["isVerified"] = false;
		}
		setSourceFileInfo(tempState);
		setTempAccessInformation({
			...tempAccessInformation,
			accessForm: tempState,
		});
	};

	const isAllVerified = sourceFileInfo.every((item: any) => item.isVerified || item.url);
	let uploadedFiles =
		tempAccessInformation.accessForm &&
		tempAccessInformation.accessForm.filter((file: any) => file.fileName);

	return (
		<Modal open={open} onClose={handleClose}>
			<Container className="modal-container-style-amenity" disableGutters>
				<div className="modal-wrapper-amenity">
					<Stack
						direction={"row"}
						position={"sticky"}
						zIndex={9999}
						top={0}
						sx={{ background: "#EFF4FC" }}
						justifyContent={"space-between"}
						alignItems={"center"}
						pl={"24px"}
						pr={"24px"}
						height={72}
						borderBottom={"1px solid #E8E8E8"}
					>
						<Box display={"flex"} alignItems={"center"}>
							<p
								style={{
									color: "#3E3E3E",
									fontSize: "20px",
									fontWeight: "500",
									fontFamily: "roboto",
								}}
							>
								{Object.keys(toBeEditedAccessInformation).length
									? `Update Access Information`
									: `Add Access Information`}
							</p>
						</Box>
						<Box>
							<IconButton onClick={handleClose}>
								<CloseOutlinedIcon sx={{ color: "#2F2F2F" }} />
							</IconButton>
						</Box>
					</Stack>
					<Stack
						style={{ padding: "6px 16px 16px 24px", borderBottom: "1px solid #E8E8E8" }}
					>
						<Stack direction={"row"} gap={"48px"}>
							<div
								style={{
									display: "flex",
									marginTop: "24px",
									justifyContent: "space-between",
								}}
							>
								<TextField
									style={{ width: "222px" }}
									variant="standard"
									label="Name"
									name="name"
									value={tempAccessInformation.name}
									onChange={(e) => {
										handleChange(e.target.value, "name");
									}}
									InputLabelProps={{
										style: { fontSize: "14px", fontWeight: "500" },
									}}
									error={checkError && !state.title}
									InputProps={{ style: { padding: "7px 0px" } }}
								/>
							</div>
							<div style={{ marginTop: "24px" }}>
								<TextField
									type="number"
									style={{ width: "222px" }}
									variant="standard"
									label="Access Fee"
									name="accessFee"
									value={tempAccessInformation.accessFee || ""}
									onChange={(e) => {
										handleChange(e.target.value, "accessFee");
									}}
									InputLabelProps={{
										style: { fontSize: "14px", fontWeight: "500" },
									}}
									error={checkError && !state.address}
									InputProps={{ style: { padding: "7px 0px" } }}
								/>
							</div>
						</Stack>
						<div
							className="sub-title-text"
							style={{
								margin: "56px 0px 24px 0px",
								fontSize: "14px",
								fontWeight: "500",
								color: "#5B5B5B",
							}}
						>
							Access Procedure
						</div>
						<TextField
							style={{ width: "75%", marginBottom: "36px" }}
							variant="outlined"
							value={tempAccessInformation.accessProcedure}
							onChange={(e) => {
								handleChange(e.target.value, "accessProcedure");
							}}
							label="Write here..."
							multiline
							InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }}
							InputProps={{ style: { minHeight: "106px" } }}
						/>

						<Stack direction={"row"} gap={"48px"}>
							<div
								style={{
									display: "flex",
									marginTop: "24px",
									justifyContent: "space-between",
								}}
							>
								<TextField
									type="number"
									style={{ width: "222px" }}
									variant="standard"
									label="First Fee"
									name="firstFee"
									value={tempAccessInformation.firstFee}
									onChange={(e) => {
										handleChange(e.target.value, "firstFee");
									}}
									InputLabelProps={{
										style: { fontSize: "14px", fontWeight: "500" },
									}}
									InputProps={{ style: { padding: "7px 0px" } }}
								/>
							</div>
							<div style={{ marginTop: "24px" }}>
								<TextField
									type="number"
									style={{ width: "222px" }}
									variant="standard"
									label="Replacement Fee"
									name="replacementFee"
									value={tempAccessInformation.replacementFee}
									onChange={(e) => {
										handleChange(e.target.value, "replacementFee");
									}}
									InputLabelProps={{
										style: { fontSize: "14px", fontWeight: "500" },
									}}
									InputProps={{ style: { padding: "7px 0px" } }}
								/>
							</div>
						</Stack>
						<TextField
							style={{ width: "335px", marginTop: "48px" }}
							variant={"standard"}
							onChange={(e) => {
								handleChange(e.target.value, "paymentFormLink");
							}}
							name="paymentFormLink"
							value={tempAccessInformation?.paymentFormLink || ""}
							label="Payment Form Link"
							InputLabelProps={{
								style: { fontSize: "14px", margin: "4px", fontWeight: "500" },
							}}
							helperText={
								tempAccessInformation.paymentFormLink?.trim().length > 0 &&
								!isValidHttpUrl(
									(tempAccessInformation.paymentFormLink as string) || ""
								)
									? "Invalid url format"
									: ""
							}
							error={
								tempAccessInformation.paymentFormLink?.trim().length > 0 &&
								!isValidHttpUrl(
									(tempAccessInformation.paymentFormLink as string) || ""
								)
							}
							InputProps={{
								style: { padding: "7px 0px" },
								endAdornment: (
									<InputAdornment position="end" style={{ paddingBottom: "7px" }}>
										<LinkIcon />
									</InputAdornment>
								),
							}}
						/>
						<div
							className="sub-title-text"
							style={{
								marginTop: "56px",
								fontSize: "14px",
								fontWeight: "500",
								color: "#5B5B5B",
							}}
						>
							Get Access Information
						</div>
						<FormControl>
							<FormGroup
								style={{ display: "flex", gap: "1rem", flexDirection: "initial" }}
							>
								{["Email", "Mail", "Portal"].map((item, infoIndex) => {
									const isChecked =
										tempAccessInformation?.getAccessInformation?.includes(item);
									return (
										<FormControlLabel
											key={infoIndex}
											style={{ color: "#383838", fontSize: "12px" }}
											control={
												<Checkbox
													style={{ color: "#9F9F9F", fontSize: "12px" }}
													checked={isChecked || false}
													onChange={(e) => {
														const { checked } = e.target;
														let getAccessInformation = [];
														if (checked) {
															getAccessInformation =
																tempAccessInformation?.getAccessInformation
																	? [
																			...tempAccessInformation?.getAccessInformation,
																			item,
																	  ]
																	: [item];
														} else {
															getAccessInformation =
																tempAccessInformation?.getAccessInformation?.filter(
																	(value: any) => value !== item
																);
														}
														handleChange(
															getAccessInformation,
															"getAccessInformation"
														);
													}}
												/>
											}
											label={item}
										/>
									);
								})}
							</FormGroup>
						</FormControl>
						<div
							className="sub-title-text"
							style={{ margin: "48px 0px 8px 0px", fontSize: "18px" }}
						>
							Access Form
						</div>
						<div className="helperText">
							Please upload access form and links if available
						</div>

						<Stack>
							<div className="sub-title-text-2" style={{ margin: "24px 0px" }}>
								Newsletter & Notification
							</div>
							{uploadedFiles?.length > 0 ? (
								<>
									<p className="helperText" style={{ fontWeight: "bold" }}>
										Uploaded File :
									</p>
									{Array.from(uploadedFiles).map((file: any, index: number) => {
										if (file?.fileName) {
											return (
												<PDFsContainerComponent
													document={`accessForm`}
													deleteClick={deleteClick}
													view={view}
													key={index}
													file={file}
												/>
											);
										}
									})}
								</>
							) : (
								""
							)}
						</Stack>

						<Stack direction={"row"} alignItems="center" spacing={2} paddingTop="10px">
							<Button
								startIcon={<AttachmentIcon color="primary" />}
								variant="outlined"
								disabled={!isAllVerified}
								onClick={addNewSourceDocument}
							>
								Attach Document
							</Button>
						</Stack>
						<Stack>
							{sourceFileInfo
								.filter((sourceFile: any) => !sourceFile.url)
								.map((item: any, index: any) => (
									<SourceIDVerificationCard
										key={index}
										index={index}
										parentIndex={index}
										item={item}
										loading={loading}
										setLoading={setLoading}
										handleSourceFile={handleSourceFile}
										handleDeleteCard={deleteSourceDocument}
									/>
								))}
						</Stack>
						<TextField
							style={{ width: "335px" }}
							variant={"standard"}
							onChange={(e) => {
								handleChange(e.target.value, "accessFormLink");
							}}
							name="accessFormLink"
							value={tempAccessInformation?.accessFormLink || ""}
							label="Access Form Link"
							InputLabelProps={{
								style: { fontSize: "14px", margin: "4px", fontWeight: "500" },
							}}
							helperText={
								tempAccessInformation.accessFormLink?.trim().length > 0 &&
								!isValidHttpUrl(
									(tempAccessInformation.accessFormLink as string) || ""
								)
									? "Invalid url format"
									: ""
							}
							error={
								tempAccessInformation.accessFormLink?.trim().length > 0 &&
								!isValidHttpUrl(
									(tempAccessInformation.accessFormLink as string) || ""
								)
							}
							InputProps={{
								style: { padding: "7px 0px" },
								endAdornment: (
									<InputAdornment position="end" style={{ paddingBottom: "7px" }}>
										<LinkIcon />
									</InputAdornment>
								),
							}}
						/>
					</Stack>
					<Stack
						style={{ marginTop: "24px", padding: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						<>
							<Button onClick={handleClose} variant="outlined">
								Cancel
							</Button>
							<Button
								onClick={onSaveClick}
								disabled={!isAllVerified}
								variant="contained"
								style={{ color: "#fff", backgroundColor: "#3576E5" }}
							>
								Save
							</Button>
						</>
					</Stack>
				</div>
			</Container>
		</Modal>
	);
};

export default AddAccessInformationModal;
